import { takeLatest, put } from "redux-saga/effects";
import { ApiCall } from "../api";
import {
  DJ_GETLISTADO_COMPLETE,
  DJ_GETLISTADO_START,
  DJ_APROBARRECHAZAR_START,
  NOT_LOADING_COMPLETE,
  NSB_MENSAJE_ADD,
} from "../../const/actionTypes";
// import { addMinutes } from "date-fns";
// import { jwtDecode } from "jwt-decode";

export function* GetDiasJefe({ payload }) {
  const p = { ...payload };
  // const token = {
  //   ...jwtDecode(p.Token),
  //   opcion: "diasJefe",
  //   browser: JSON.stringify(window.navigator.userAgent),
  //   conductorsol: p.Conductor,
  // };
  // yield ApiCall("/api/Log/GrabarLog", "POST", JSON.stringify(token), p.Token);
  // let nbf = null;
  // try {
  //   nbf = new Date(token.nbf * 1000);
  // } catch {}
  // if (token && (!nbf || (nbf && nbf >= addMinutes(new Date(), -3)))) {
  yield put({ type: NOT_LOADING_COMPLETE, payload: true });

  const dj = yield ApiCall(
    "/api/Dias/ObtenerSolicitudesJefe",
    "POST",
    JSON.stringify({
      Sigla: p.Sigla,
      Token: p.Token,
    }),
    p.Token
  );
  if (dj) {
    yield put({
      type: DJ_GETLISTADO_COMPLETE,
      payload: dj.Results,
    });
  }

  yield put({ type: NOT_LOADING_COMPLETE, payload: false });
  // }
}
export function* AprobarRechazar({ payload }) {
  yield put({ type: NOT_LOADING_COMPLETE, payload: true });
  const p = { ...payload };
  // const token = {
  //   ...jwtDecode(p.Token),
  //   opcion: "diasJefe/aprobarRechazar",
  //   browser: JSON.stringify(window.navigator.userAgent),
  //   conductorsol: p.Conductor,
  // };
  // yield ApiCall("/api/Log/GrabarLog", "POST", JSON.stringify(token), p.Token);
  // let nbf = null;
  // try {
  //   nbf = new Date(token.nbf * 1000);
  // } catch {}
  // if (
  //   token &&
  //   token.conductor &&
  //   token.conductor.toString() === p.Conductor.toString() &&
  //   (!nbf || (nbf && nbf >= addMinutes(new Date(), -3)))
  // ) {
  const res = yield ApiCall(
    p.Aprobar === "aprobar"
      ? "/api/Dias/AceptarSolicitudJefe"
      : "/api/Dias/RechazarSolicitudJefe",
    "POST",
    JSON.stringify(p),
    p.Token
  );
  let mensaje;
  if (res && !res.Error) {
    mensaje = {
      mensaje:
        "Solicitud " +
        (p.Aprobar === "aprobar" ? "aprobada" : "rechazada") +
        " con éxito.",
      variant: "success",
    };
    const dj = yield ApiCall(
      "/api/Dias/ObtenerSolicitudesJefe",
      "POST",
      JSON.stringify({
        Sigla: p.Sigla,
      }),
      p.Token
    );
    if (dj) {
      yield put({
        type: DJ_GETLISTADO_COMPLETE,
        payload: dj.Results,
      });
    }
  } else {
    mensaje = {
      mensaje:
        "Hubo un error al " +
        p.Aprobar +
        " la solicitud.\nIntente nuevamente mas tarde.",
      variant: "error",
    };
  }
  yield put({ type: NOT_LOADING_COMPLETE, payload: false });
  yield put({ type: NSB_MENSAJE_ADD, payload: mensaje });
  // }
}
export default function* diasjefe() {
  yield takeLatest(DJ_GETLISTADO_START, GetDiasJefe);
  yield takeLatest(DJ_APROBARRECHAZAR_START, AprobarRechazar);
}
